import { render } from "./Plats.vue?vue&type=template&id=188ebc5b&scoped=true"
import script from "./Plats.vue?vue&type=script&lang=js"
export * from "./Plats.vue?vue&type=script&lang=js"

import "./Plats.vue?vue&type=style&index=0&id=188ebc5b&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188ebc5b"]])

export default __exports__